import React, { useContext } from "react";

import { Button, Text, Link, ResourceItem, InlineStack } from "@shopify/polaris";
import PropTypes from "prop-types";
// import { useQuery } from "@apollo/client";

// import from lib
import { PrivateContext } from "lib/context";
import { withErrorBoundary } from "lib/hoc";
import { useNavigate } from "react-router-dom";

const SellerPlanList = (props) => {
  const { cms, currentUser } = useContext(PrivateContext);
  const navigate = useNavigate();
  // const [profileImage, setProfileImage] = useState();

  const { item, isStripe, keyIndex, loading, setMessageToast } = props;

  const { _id, code, name } = item;

  return (
    <>
      <ResourceItem id={_id} sortOrder={keyIndex}>
        <InlineStack>
          <Text as="span" variant="bodySm">
            {/* <div className="ellipsis"> */}
            <Text as="h2" variant="headingSm">
              {!isStripe && (
                <Link onClick={() => navigate(`/setting/plan/edit/${_id}`)}>
                  <Text as="span">{name}</Text>
                </Link>
              )}
              {isStripe && <Text as="span">{name}</Text>}
            </Text>
            {/* </div>/ */}
          </Text>
          <Text variant="bodySm" as="p">
            <div className="ellipsis">
              <Text as="span" tone="subdued">
                {code}
              </Text>
              <br />
            </div>
          </Text>
          {!isStripe && (
            <Button onClick={() => navigate(`/setting/plan/edit/${_id}`)}>{cms("section.button.edit")}</Button>
          )}
        </InlineStack>
      </ResourceItem>
    </>
  );
};

SellerPlanList.defaultProps = {
  item: {},
  keyIndex: "",
};

SellerPlanList.propTypes = {
  item: PropTypes.shape(PropTypes.object),
  keyIndex: PropTypes.number,
};

export default withErrorBoundary(SellerPlanList);
